import { Link, Navigate } from "react-router-dom";
import { School, ChevronRight } from "lucide-react";
import { useMe } from "@/components/admin/AdminGuard";

export default function AdminHome() {
  const me = useMe();
  if (me.role === "super_admin") return <Navigate to="/super" replace />;
  if (me.schools.length === 1) return <Navigate to={`/admin/schools/${me.schools[0].id}`} replace />;
  return (
    <div className="min-h-screen bg-brand-soft dots-bg flex items-center justify-center px-4" data-testid="school-picker">
      <div className="bg-white rounded-3xl border p-6 sm:p-8 w-full max-w-md">
        <h1 className="text-2xl font-semibold mb-1">Choose a school</h1>
        <p className="text-sm text-stone-500 mb-5">Your email manages more than one school.</p>
        <div className="space-y-2">
          {me.schools.map((s) => (
            <Link key={s.id} to={`/admin/schools/${s.id}`} data-testid={`school-picker-${s.slug}`}
              className="flex items-center gap-3 p-3 rounded-2xl border hover:bg-stone-50 transition-colors">
              <School className="w-5 h-5 text-brand" />
              <span className="flex-1 font-medium">{s.name}</span>
              <ChevronRight className="w-4 h-4 text-stone-400" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
